import { render, staticRenderFns } from "./n2History.vue?vue&type=template&id=68e7dd28&scoped=true&"
import script from "./n2History.vue?vue&type=script&lang=js&"
export * from "./n2History.vue?vue&type=script&lang=js&"
import style0 from "./n2History.vue?vue&type=style&index=0&id=68e7dd28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7dd28",
  null
  
)

export default component.exports